import tokens from '@nike/design-system-base';
import { getMaxWidth } from '@nike/shop-apis/css/hooks';
// all commented values are from design-system-base v^3.0.1
// {
//   "mobile": 0,
//   "tablet": 600,
//   "desktop": 960,
//   "largeDesktop": 1440,
//   "extraLargeDesktop": 1920
// }

const mediaQueries = {
  sm: `@media only screen and (min-width: ${tokens.bp('mobile')}px)`, // 0
  md: `@media only screen and (min-width: ${tokens.bp('tablet')}px)`, // 600
  lg: `@media only screen and (min-width: ${tokens.bp('desktop')}px)`, // 960
  xl: `@media only screen and (min-width: ${tokens.bp('largeDesktop')}px)`, // 1440
  xxl: `@media only screen and (min-width: ${tokens.bp('extraLargeDesktop')}px)`, // 1920
};
export default mediaQueries;

export const smallerThan = {
  // tokens.bp('mobile') is 0, so no need to have max-width 0
  md: `@media only screen and (max-width: ${getMaxWidth('tablet')}px)`, // 599
  lg: `@media only screen and (max-width: ${getMaxWidth('desktop')}px)`, // 959
  xl: `@media only screen and (max-width: ${getMaxWidth('largeDesktop')}px)`, // 1439
  xxl: `@media only screen and (max-width: ${getMaxWidth('extraLargeDesktop')}px)`, // 1919
};
